<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px">
    <v-btn color="accent" class="elevation-2" v-show="!drawer" top right fixed fab slot="activator"><v-icon>add</v-icon></v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Nueva Incidencia</span>
      </v-card-title>
      <v-card-text>
        <label v-if="process">{{ `Proceso ${process.id}` }}</label>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-form ref="form" v-model="valid">
                <v-select
                  v-model="incident.severity"
                  :items="masters.severities"
                  :cache-items="true"
                  :loading="loading"
                  :rules="requiredRules"
                  label="Criticidad *"
                  item-value="id"
                  item-text="name"
                  @change="fieldErrors.severity = []"
                  :error-messages="fieldErrors.severity"
                  required
                ></v-select>
                <v-select
                  v-model="incident.status"
                  :items="masters.statuses"
                  :loading="loading"
                  :cache-items="true"
                  :rules="requiredRules"
                  label="Estado *"
                  item-value="id"
                  item-text="name"
                  @change="fieldErrors.status = []"
                  :error-messages="fieldErrors.status"
                  required
                ></v-select>
                <v-autocomplete
                  v-model="incident.machine"
                  :items="masters.machines"
                  :loading="loading"
                  :cache-items="true"
                  label="Máquina"
                  item-value="id"
                  item-text="name"
                  @change="fieldErrors.machine = []"
                  :error-messages="fieldErrors.machine"
                ></v-autocomplete>
                <v-text-field
                  label="Operador"
                  type="text"
                  v-model="incident.operator"
                />
                <v-text-field
                  label="Duración"
                  suffix="minutos"
                  type="number"
                  v-model="incident.duration"
                  @input="fieldErrors.duration = []"
                  :error-messages="fieldErrors.duration"
                  />
                <v-textarea
                  v-model="incident.description"
                  :rules="requiredRules"
                  label="Descripción *"
                  @input="fieldErrors.description = []"
                  :error-messages="fieldErrors.description"
                  required></v-textarea>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*campos obligatorios</small>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="accent" @click.native="closeDialog()">Cancelar</v-btn>
          <v-btn
            depressed
            color="accent"
            @click="submit"
            :disabled="!valid"
            >
              Crear
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api/app'
import formMixin from '@/mixins/formMixin'
import mutationsMixin from '@/mixins/mutationsMixin'

export default {
  props: ['callback', 'drawer', 'process', 'masters'],
  mixins: [formMixin, mutationsMixin],
  data () {
    return {
      dialog: false,
      incident: {
        operator: null,
        severity: null,
        status: null,
        duration: null,
        description: null,
        machine: null
      },
      requiredRules: [
        v => !!v || 'Campo obligatorio'
      ]
    }
  },
  methods: {
    onSubmit () {
      if (this.process) {
        this.incident.process = this.process.id
      }

      return api.createIncident(this.incident)
    },
    onSuccess (response) {
      this.closeDialog()
      if (this.callback) {
        this.callback()
      } else {
        let route = {name: 'incident-detail', params: {'id': response.id}}
        this.$router.push(route)
      }
      this.success('Incidencia creada con éxito')
    },
    closeDialog () {
      this.incident = {severity: null, status: null, description: null}
      this.$refs.form.reset()
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/IncidentModal.vue